import React                from "react";
import {View}               from "react-native";
import {connect}            from "react-redux";
import ScreenCamera         from "./ScreenCamera";
import ScreenCategory       from "./ScreenCategory";
import ScreenCredits        from "./ScreenCredits";
import ScreenGame           from "./ScreenGame";
import ScreenSettings       from "./ScreenSettings";
import ScreenSettingsPlayer from "./ScreenSettingsPlayer";
import ScreenTitle          from "./ScreenTitle";
import * as Screens         from "../../constants/Screens";
import styles               from "../../styles/Styles";

const Screen = (props) => {
    var screen = null;
    switch(props.screen) {
        case Screens.CAMERA:
            screen = <ScreenCamera />;
            break;
        case Screens.CATEGORY:
            screen = <ScreenCategory />;
            break;
        case Screens.CREDITS:
            screen = <ScreenCredits />;
            break;
        case Screens.GAME:
            screen = <ScreenGame />;
            break;
        case Screens.SETTINGS:
            screen = <ScreenSettings />;
            break;
        case Screens.SETTINGS_PLAYER:
            screen = <ScreenSettingsPlayer />;
            break;
        case Screens.TITLE:
            screen = <ScreenTitle />;
            break;
    }

    return (
        <View style={styles.background}>
            {screen}
        </View>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
        screen: state.screen
    };
};

export default connect(mapStateToProps)(Screen);